import type { FuelSensor } from "../../Layouts/admin/components/sections/devices/utils/fuelSensor";

// SG guarda la calibración en el device de v5 (PUT /device fuel_sensor), que
// también refresca la meta de la ingesta y re-sincroniza el equipo a SG. Por eso
// sólo se manda si cambió: guardar el formulario de SG sin tocar la sección no
// debe disparar ese PUT. next viene de fuelSensorPayload (undefined = no mandar).
export function fuelSensorChanged(
  next: FuelSensor | null | undefined,
  current: FuelSensor | null | undefined
): boolean {
  if (next === undefined) return false;
  if (next === null) return !!current;
  return (
    !current ||
    next.param !== current.param ||
    Number(next.empty_raw) !== Number(current.empty_raw) ||
    Number(next.full_raw) !== Number(current.full_raw)
  );
}
